import Gator from 'gator';
import Headroom from 'headroom.js';

let header;

// comment out the following block of code, because it doesn't work on the live page, and with update we want the same behavior as before

// _gg.onReady.PageHeader = () => {
//     header = document.querySelector('.page-header');

//     if (header && header.classList.contains('headroom')) {
//         let headr = new Headroom(header, {
//             //tolerance: 0,
//             offset: 100,
//         });
//         headr.init();
//     }
// };

Gator(_gg.html).on('click', '.hamburger-icon', function () {
    document.body.classList.toggle('-menuopen');
    this.blur();
});

Gator(_gg.html).on(
    'click',
    '.nav__element--level1.nav__element--hassub > a',
    (event) => {
        event.stopPropagation();
    }
);

Gator(_gg.html).on(
    'click',
    '.nav__element--level1.nav__element--hassub',
    function () {
        this.classList.toggle('-listopen');
    }
);
